import React from 'react'
import { Box, Typography } from '@mui/material'
import { Zap, Calendar, TrendingUp, Flame } from 'lucide-react'
import { useGetEngagementStatsQuery } from 'graphql/generated/graphql'

export default function EngagementStatsBar(): JSX.Element | null {
  const { data } = useGetEngagementStatsQuery({ pollInterval: 60000 })
  const stats = data?.getEngagementStats

  if (!stats || stats.total === 0) return null

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: { xs: 1, md: 2 },
        mb: 3,
        p: { xs: 1.5, md: 2 },
        backgroundColor: 'rgba(168,85,247,0.05)',
        border: '1px solid rgba(168,85,247,0.15)',
        borderRadius: '14px',
      }}
    >
      <StatItem
        icon={<Zap size={14} color="#a855f7" />}
        value={stats.today}
        label="Today"
      />
      <StatItem
        icon={<Calendar size={14} color="#a855f7" />}
        value={stats.thisWeek}
        label="Conversations this week"
      />
      <StatItem
        icon={<TrendingUp size={14} color="#a855f7" />}
        value={stats.thisMonth}
        label="This month"
      />
      {stats.streakDays > 1 && (
        <StatItem
          icon={<Flame size={14} color="#f59e0b" />}
          value={stats.streakDays}
          label="Day streak"
          highlight
        />
      )}
    </Box>
  )
}

function StatItem({
  icon,
  value,
  label,
  highlight,
}: {
  icon: React.ReactNode
  value: number
  label: string
  highlight?: boolean
}): JSX.Element {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flex: { xs: '1 1 45%', md: '0 0 auto' } }}>
      {icon}
      <Box>
        <Typography
          sx={{
            color: highlight ? '#f59e0b' : 'white',
            fontWeight: 700,
            fontSize: { xs: '16px', md: '18px' },
            lineHeight: 1,
          }}
        >
          {value}
        </Typography>
        <Typography sx={{ color: 'rgba(255,255,255,0.4)', fontSize: '11px', lineHeight: 1.2 }}>
          {label}
        </Typography>
      </Box>
    </Box>
  )
}
